import React from 'react';
import Divider from 'material-ui/Divider';
import Session from './Session';

const DateData= (props)=>(<div className='on-date-outer'>
    <Divider/>
        <div className='on-date-caption'> {props.items[0].date}</div>

    <div className='on-date-container'>
        {props.items.map((item, index)=>(<Session key={index} item={item}/>))}
    </div>
</div>);

export default DateData;